/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_AcceleratedInputs */

const en_thankyou_accelerated = /** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accelerated`)
};

const es_thankyou_accelerated = /** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acelerado`)
};

const fr_thankyou_accelerated = /** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accéléré`)
};

const de_thankyou_accelerated = /** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschleunigt`)
};

const id_thankyou_accelerated = /** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipercepat`)
};

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const ja_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const zh_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const ar_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const it_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const ru_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const pt_thankyou_accelerated = en_thankyou_accelerated;

/** @type {(inputs: Thankyou_AcceleratedInputs) => LocalizedString} */
const ko_thankyou_accelerated = en_thankyou_accelerated;

/**
* | output |
* | --- |
* | "Accelerated" |
*
* @param {Thankyou_AcceleratedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_accelerated = /** @type {((inputs?: Thankyou_AcceleratedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_AcceleratedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_accelerated(inputs)
	if (locale === "es") return es_thankyou_accelerated(inputs)
	if (locale === "fr") return fr_thankyou_accelerated(inputs)
	if (locale === "de") return de_thankyou_accelerated(inputs)
	if (locale === "ja") return ja_thankyou_accelerated(inputs)
	if (locale === "zh") return zh_thankyou_accelerated(inputs)
	if (locale === "ar") return ar_thankyou_accelerated(inputs)
	if (locale === "id") return id_thankyou_accelerated(inputs)
	if (locale === "it") return it_thankyou_accelerated(inputs)
	if (locale === "ru") return ru_thankyou_accelerated(inputs)
	if (locale === "pt") return pt_thankyou_accelerated(inputs)
	return ko_thankyou_accelerated(inputs)
});